import React from 'react';
import StartSection from '../../components/employees/Start';


const HomePage = () => {
  return (
    <div className='commom-001'>
        <StartSection />
    </div>
  );
};

export default HomePage;
